import { TemplateDefinition, toMessageTemplateModel } from '@/features/templates/templatePreview'
import { devzappApi } from '@/services/api'
import { put } from 'redux-saga/effects'
import { fetchMessageTemplatesAction } from '../../actions'

type MessageTemplateApiItem = { message: TemplateDefinition }

export function* fetchMessageTemplatesSaga(action: ReturnType<typeof fetchMessageTemplatesAction.request>) {
  try {
    const { campaignId } = action.payload
    const response = yield devzappApi.get<MessageTemplateApiItem[] | { data: MessageTemplateApiItem[] }>(
      '/api-meta-devzapp/message-template/campaigns',
      {
        params: {
          campaignsId: campaignId,
          page: 1,
          size: 999,
          imported: true,
          noVariables: true
        }
      }
    )

    const items = Array.isArray(response.data) ? response.data : response.data.data
    const messageTemplates = (items || []).map(item => toMessageTemplateModel(item.message))

    yield put(fetchMessageTemplatesAction.success({ messageTemplates }))
  } catch (error) {
    yield put(fetchMessageTemplatesAction.failure(error))
  }
}
